import React from 'react'
import { customSelectStyles } from '../../styles/classes/GeneralClasses'
import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material'

import { menuProps } from '../../styles/mui_custom_theme'
export const CustomSelect = ({
  nonSortedOptions,
  placeholder,
  options,
  required,
  title,
  name,
  value,
  onChange,
  disabledIndexes, // for addding indexes in the list:  take into account that we sort options or not in this component (add the index based on frontend)
  ...rest
}) => {
  const { classes } = customSelectStyles()
  let sortedOptions = options
  if (!nonSortedOptions) {
    sortedOptions = options?.sort()
  }

  return (
    <FormControl className={classes.formControl} size="small">
      <Box className={classes.titleContainer}>
        {required && <Typography className={classes.titleSymbol}>*</Typography>}
        <Typography className={classes.titleFontStyle}>{title}</Typography>
      </Box>

      <Select
        {...rest}
        id={name}
        name={name}
        MenuProps={menuProps}
        className={classes.selectStyle}
        value={value}
        onChange={onChange}
        displayEmpty
        renderValue={selected => {
          if (!selected || selected === '') {
            return (
              <div className={classes.intemsFontPlaceholder}>
                {placeholder ?? ''}
              </div>
            )
          }

          return <div className={classes.itemsFontStyle}>{selected}</div>
        }}
      >
        {sortedOptions?.map((option, index) => {
          if (disabledIndexes?.includes(index)) {
            return (
              <Box key={index} className={classes.disabledOptionContainer}>
                <Typography className={classes.disabledOptionText}>
                  {option}
                </Typography>
              </Box>
            )
          }
          return (
            <MenuItem
              key={index}
              value={option}
              className={classes.itemsFontStyle}
            >
              {option}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}

export default CustomSelect
